// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","grey-font-color":"#000000","form":"_15zZtWM","fieldset":"N1yhShT","link":"i05fhgU","buttons":"K9473-m"};